import React, { ReactElement, useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import VideoMediaCarousel from './VideoMediaCarousel';
import ToolsCarousel from './ToolsCarousel';
import { Colors } from '../../enums/enums';
import { useDispatch, useSelector } from 'react-redux';
import { findUserProfile, getUserProfile } from '../../redux/actions/user';
import { fetchUserGroups, getUserGroups } from '../../redux/actions/groups';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    section: {
      font: 'Roboto',
      fontSize: '20px',
      lineHeight: '20px',
      fontWeight: 700,
      marginTop: '100px',
      marginLeft: '20px',
      color: Colors.TextElevated
    },
    container: {
      marginLeft: '20px',
      marginTop: '10px',
    }
  })
);

export default function LearningCenter(): ReactElement {
  const dispatch = useDispatch();
  const userId = localStorage.getItem('LOCELLE:USER');
  const user = useSelector(getUserProfile);
  const userGroups = useSelector(getUserGroups);
  const classes = useStyles();

  const SPECIFIC_COHORT_ID = 'bf486817-5c58-491f-812e-e8b9af91ec34';

  // Check if user is a participant in the specific cohort
  const isInSpecificCohort = userGroups?.some(
    (group) => group.id === SPECIFIC_COHORT_ID
  );

  useEffect(() => {
    if (userId) {
      dispatch(findUserProfile(userId));
      dispatch(fetchUserGroups(userId));
    }
  }, [userId]);

  return (
    <div className={classes.container}>
      <ToolsCarousel user={user} />
      {isInSpecificCohort && (
        <>
          <div className={classes.section}>Video Library</div>
          <VideoMediaCarousel />
        </>
      )}
    </div>
  );
}
